<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="12">
        <shop-select  distributors  @update="storeChange" @init="initChange"></shop-select> <!--distributors wxshops 需要哪个api传哪个-->
      </el-col>
      <el-col :md="8" :lg="5">
          <el-input placeholder="手机号" v-model="params.mobile" clearable><el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button></el-input>
      </el-col>
      <el-col :span="3" class="content-right">
        <el-button type="primary" icon="plus" @click="handleAddSalesman">添加导购员</el-button>
      </el-col>
    </el-row>
    <el-row>

  </el-row>
    <el-tabs type="border-card" v-model="activeName">
      <el-tab-pane label="导购员列表" name="admin"></el-tab-pane>
      <el-table :data="list" :height="wheight-160" v-loading="loading">
        <el-table-column prop="salesman_name" label="姓名"></el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
        <el-table-column prop="child_count" label="会员数量">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.child_count > 0" @click="searchMembers(scope.row)">{{scope.row.child_count}}</el-button>
            <span v-else>0</span>
          </template>
        </el-table-column>
        <el-table-column label="是否启用">
          <template slot-scope="scope">
            <el-switch  v-model="scope.row.is_valid" active-value="true" inactive-value="false" active-color="#13ce66"  inactive-color="#ff4949" @change="defaultSwitchChange(scope.row)"></el-switch>
          </template>
        </el-table-column>
        </el-table-column>
        <el-table-column prop="distributor_name" label="所属店铺"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="operating-icons">
              <i class="iconfont icon-edit1" @click="handleUpdateSelasman(scope.row)"></i>
              <i class="mark iconfont icon-trash-alt1" @click="handleDeleteSelasman(scope.$index, scope.row)"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="total_count > params.pageSize" class="content-padded content-center">
        <el-pagination background
        layout="prev, pager, next, total"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :total="total_count" :page-size="params.pageSize">
        </el-pagination>
      </div>
    </el-tabs>

    <el-dialog title="添加/编辑导购员" :visible.sync="dialog" :close-on-click-modal="false">
      <el-form v-model="form" label-width="160px">
        <el-form-item label="所属店铺">
          <shop-select  distributors  @update="addSelectStoreChange" @init="initChange" :shop-id-default="shopname"></shop-select> <!--distributors wxshops 需要哪个api传哪个-->
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.mobile" placeholder="请输入手机号" style="width:193px"></el-input>
        </el-form-item>
        <el-form-item label="导购员姓名">
          <el-input v-model="form.salesman_name" placeholder="请输入导购员姓名" style="width:193px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer content-center">
        <el-button type="primary" @click="handleAddSelasman">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { getSalesmanList, updateSalesman, addSalesman} from '../../../api/marketing'
  import shopSelect from '@/components/shopSelect'
  export default {
    components: {
      shopSelect,
    },
    data () {
      return {
        dialog: false,
        activeName: 'admin',
        list: [],
        total_count: 0,
        loading: false,
        salesman_id: '',
        params: {
          page: 1,
          pageSize: 20
        },
        form: {
          distributor_id: '',
          mobile: '',
          salesman_name:''
        },
        shopname:'',
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      searchMembers(row) {
        let routeData = this.$router.resolve({ path: '/member/member', query: {salesman_mobile: row.mobile}});
        window.open(routeData.href, '_blank');
      },
      handleAddSalesman() {
        this.dialog = true
        this.salesman_id= false
        this.form.distributor_id = ''
        this.form.mobile = ''
        this.form.salesman_name = ''
      },
      addSelectStoreChange(data) {
        this.form.distributor_id = data.shop_id
      },
      storeChange (params) {
        params && params.shop_id
        this.params.distributor_id = params.shop_id
        this.params.page = 1
        this.getList()
      },
      initChange () {
        this.shopId = ''
      },
      numberSearch () {
        this.params.page = 1
        this.getList()
      },
      handleUpdateSelasman(row) {
        this.dialog = true
        this.form.distributor_id = row.distributor_id
        this.form.mobile = row.mobile
        this.form.salesman_name = row.salesman_name
        this.salesman_id = row.salesman_id
        this.shopname=row.distributor_name
      },
      handleDeleteSelasman(index, row) {
        this.$confirm('此操作将删除该导购员, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          updateSalesman(row.salesman_id, {is_valid: 'delete'}).then(response => {
            this.list.splice(index, 1)
            this.$message({
              type: 'success',
              message: '操作成功'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      defaultSwitchChange (row) {
        updateSalesman(row.salesman_id, {is_valid: row.is_valid}).then(response => {
          this.$message({ type: 'success', message: '操作成功'})
        })
      },
      handleAddSelasman() {
        if (this.salesman_id) {
          this.updateSelasmanAction()
        } else {
          this.addSelasmanAction()
        }
      },
      updateSelasmanAction () {
        updateSalesman(this.salesman_id, this.form).then(res => {
            this.form = {
              distributor_id: '',
              mobile: '',
              salesman_name:''
            }
            this.dialog = false
            this.getList()
            this.$message({ type: 'success', message: '操作成功' })
        })
      },
      addSelasmanAction() {
        addSalesman(this.form).then(res => {
            this.form = {
              distributor_id: '',
              mobile: '',
              salesman_name:''
            }
            this.dialog = false
            this.getList()
            this.$message({ type: 'success', message: '操作成功' })
        })

      },
      getList () {
        this.loading = true
        getSalesmanList(this.params).then(response => {
          if(response.data.data.list) {
            this.list = response.data.data.list
            this.total_count = Number(response.data.data.total_count)
          }
          this.loading = false
        })
      },
    },
    mounted () {
       this.getList()
    }
  }
</script>

<style scoped lang="scss">
  .upload-preview {
    text-align: center;
    max-width: 200px;
    border: 1px solid #ddd;
    padding: 10px;
    position: relative;
    img {
      max-width: 200px;
      margin: 0 auto;
    }
  }
  .text-ellipsis {
    display: inline-block;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// salesman.vue?67f7df5c